import { FontWeights } from '@fluentui/theme';
import { ITextStyles } from 'office-ui-fabric-react';

export const bold: ITextStyles = { root: { fontWeight: FontWeights.bold }};
export const semibold: ITextStyles = { root: { fontWeight: FontWeights.semibold } };
export const regular: ITextStyles = { root: { fontWeight: FontWeights.regular } };